import React from 'react';

import { useTranslation } from '@crehana/i18n';
import { useAmplitude } from '@crehana/analytics';
import { Checkbox } from '@crehana/ui';

import useCatalogCourseDuration, {
  DurationItemExtended,
} from 'Jsx/Catalog/hooks/useCatalogCourseDuration';
import HamburgerMenu from 'Jsx/Catalog/components/HamburgerMenu';

interface DurationFilterProps {
  scrollTop?: () => void;
}

const DurationFilter: React.FC<DurationFilterProps> = ({ scrollTop }) => {
  const { data, selectDuration, hasSelectedItems } = useCatalogCourseDuration();
  const { t } = useTranslation();
  const { logEvent } = useAmplitude();

  const onSelectDuration = (item: DurationItemExtended) => {
    selectDuration(item);
    scrollTop?.();

    logEvent({
      event: 'Catalog Filter',
      data: {
        FilterType: 'Duration',
        DurationTag: item.tag,
        DurationHourIni: item.hourIni,
        DurationHourEnd: item.hourEnd,
      },
    });
  };

  return (
    <HamburgerMenu
      isDefaultOpen={hasSelectedItems}
      label={t('CATALOG_FILTER_DURATION')}
    >
      <ul>
        {data.map(item => (
          <li key={item.tag} className="py-4 pl-16">
            <Checkbox
              checked={item.selected}
              name={item.description!}
              label={item.description!}
              disabled={item.disabled}
              onChange={() => onSelectDuration(item)}
              wrapperProps={{
                'aria-checked': item.selected,
                'aria-disabled': item.disabled,
                'aria-label': item?.description!,
              }}
            />
          </li>
        ))}
      </ul>
    </HamburgerMenu>
  );
};

export default DurationFilter;
